/**
 * Nội dung thanh toán
 */
export default {
  DescriptionDetail: 'description', // Diễn giải chi tiết
  DescriptionGeneral: 'journal_memo', // Diễn giải chứng từ
  BudgetItemName: 'budget_item_name', // Tên mục
  BudgetSubItemName: 'budget_sub_item_name', // Tên tiểu mục
};
